export default "__VITE_ASSET__3f8be81b__"